var _path, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppDiagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_188_868",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15C0 17.3577 0.706289 19.7147 1.325 21.0027C1.98895 22.3848 2.96316 23.9436 4.33594 25.3125C5.45094 26.4244 7.01602 27.5158 8.51562 28.2266C10.0787 28.9674 11.8223 29.5552 14.9609 29.8438C16.5633 29.9911 20 30 20 30C20 30 23.4367 29.9911 25.0391 29.8438C28.1777 29.5552 29.9212 28.9674 31.4844 28.2266C32.984 27.5158 34.549 26.4244 35.6641 25.3125C37.0368 23.9436 38.0111 22.3848 38.675 21.0027C39.2938 19.7147 40 17.3577 40 15C40 12.6423 39.2938 10.2853 38.675 8.99727C38.0111 7.6152 37.0368 6.05641 35.6641 4.6875C34.549 3.57562 32.984 2.48422 31.4844 1.77344C29.9212 1.03258 28.1777 0.444805 25.0391 0.15625C23.4367 0.00894532 20 0 20 0C20 0 16.5633 0.00894532 14.9609 0.15625C11.8223 0.444805 10.0787 1.03258 8.51562 1.77344C7.01602 2.48422 5.45094 3.57562 4.33594 4.6875C2.96316 6.05641 1.98895 7.6152 1.325 8.99727C0.706289 10.2853 0 12.6423 0 15Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_188_868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 15C0 17.3577 0.706289 19.7147 1.325 21.0027C1.98895 22.3848 2.96316 23.9436 4.33594 25.3125C5.45094 26.4244 7.01602 27.5158 8.51562 28.2266C10.0787 28.9674 11.8223 29.5552 14.9609 29.8438C16.5633 29.9911 20 30 20 30C20 30 23.4367 29.9911 25.0391 29.8438C28.1777 29.5552 29.9212 28.9674 31.4844 28.2266C32.984 27.5158 34.549 26.4244 35.6641 25.3125C37.0368 23.9436 38.0111 22.3848 38.675 21.0027C39.2938 19.7147 40 17.3577 40 15C40 12.6423 39.2938 10.2853 38.675 8.99727C38.0111 7.6152 37.0368 6.05641 35.6641 4.6875C34.549 3.57562 32.984 2.48422 31.4844 1.77344C29.9212 1.03258 28.1777 0.444805 25.0391 0.15625C23.4367 0.00894532 20 0 20 0C20 0 16.5633 0.00894532 14.9609 0.15625C11.8223 0.444805 10.0787 1.03258 8.51562 1.77344C7.01602 2.48422 5.45094 3.57562 4.33594 4.6875C2.96316 6.05641 1.98895 7.6152 1.325 8.99727C0.706289 10.2853 0 12.6423 0 15Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_868)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_188_868)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8266 15.0135C16.8266 12.505 18.1017 10.2983 20.0328 9.01318C18.9092 8.26567 17.5646 7.82965 16.1182 7.82965C12.1849 7.82965 8.99683 11.0457 8.99683 15.0135C8.99683 18.9812 12.1849 22.1975 16.1182 22.1975C17.5646 22.1975 18.9092 21.7615 20.0328 21.0144C18.1017 19.7286 16.8266 17.5221 16.8266 15.0135Z",
    fill: "#1AAEC0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9471 7.82959C22.5008 7.82959 21.1564 8.26561 20.0327 9.01325C21.9632 10.2983 23.2386 12.5049 23.2386 15.0135C23.2386 17.522 21.9632 19.7287 20.0327 21.0143C21.1564 21.7616 22.5008 22.1975 23.9471 22.1975C27.8806 22.1975 31.0684 18.9813 31.0684 15.0135C31.0684 11.0456 27.8806 7.82959 23.9471 7.82959Z",
    fill: "#E80F8A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2389 15.0135C23.2389 12.505 21.9635 10.2983 20.033 9.01315C18.1017 10.2983 16.8267 12.505 16.8267 15.0135C16.8267 17.5221 18.1017 19.7286 20.033 21.0144C21.9635 19.7286 23.2389 17.5221 23.2389 15.0135Z",
    fill: "#642A7B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.0379,
    height: 14.6446,
    fill: "white",
    transform: "translate(8.98096 7.6777)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_188_868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.0717,
    height: 14.3679,
    fill: "white",
    transform: "translate(8.99683 7.82959)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppDiagram);
export default __webpack_public_path__ + "static/media/AppDiagram.28c1db20442a5e0b855e4f8c38c4d117.svg";
export { ForwardRef as ReactComponent };